import getMe from '../graphql/auth/getMe';
import {GroupEditingLevelType, GroupMemberRoleType} from '../graphql/groups.datatypes';
import {checkRole} from '../components/Can/Can';
import {User} from '../graphql/auth';

export const checkEditLevel = () => {
    const meData = getMe();
    const wcvAdmin = checkRole(['super-admin', 'admin']);
    const thirdPartyAdmin = checkRole(['admin-3rd-party']);

    return (groupId: number, editingLevel: number): boolean => {
        if (meData.data) {
            const me: User = meData.data.me;
            if (!me) return false;

            if (editingLevel >= GroupEditingLevelType.WCV_ONLY && wcvAdmin) { //Only WCV admins
                return true;
            }

            if (editingLevel >= GroupEditingLevelType.THIRD_PARTY && (
                wcvAdmin ||
                (thirdPartyAdmin && me.associatedGroups && me.associatedGroups!.find(group => group.id === groupId))
            )) { //WCV Admins or 3rd party admins associated with this group
                return true;
            }

            if (editingLevel >= GroupEditingLevelType.PRIMARY_LEADER &&
                (
                    wcvAdmin ||
                    (thirdPartyAdmin && me.associatedGroups && me.associatedGroups!.find(group => group.id === groupId)) ||
                    (me.groupMembers && me.groupMembers.find(member => member.group_role === GroupMemberRoleType.PRIMARY_LEADER && member.group_id === groupId))
                )
            ) {
                return true;
            }

            if (editingLevel >= GroupEditingLevelType.ALL_LEADERS &&
                (
                    wcvAdmin ||
                    (thirdPartyAdmin && me.associatedGroups && me.associatedGroups!.find(group => group.id === groupId)) ||
                    (me.groupMembers && me.groupMembers!.find(member => (member.group_role === GroupMemberRoleType.PRIMARY_LEADER || member.group_role === GroupMemberRoleType.LEADER) && member.group_id === groupId))
                )
            ) {
                return true;
            }

            if (editingLevel >= GroupEditingLevelType.PRIMARY_PAYING_MEMBER &&
                (
                    wcvAdmin ||
                    (thirdPartyAdmin && me.associatedGroups && me.associatedGroups!.find(group => group.id === groupId)) ||
                    (me.groupMembers && me.groupMembers!.find(member => (member.group_role === GroupMemberRoleType.PRIMARY_LEADER || member.group_role === GroupMemberRoleType.LEADER) && member.group_id === groupId)) ||
                    (me.billingPartyMembers && me.billingPartyMembers.find(member => (member.primary_paying_member && member.billingParty && member.billingParty.booking && member.billingParty.booking.group_id === groupId)))
                )
            ) {
                return true;
            }

            if (editingLevel >= GroupEditingLevelType.ALL_PAYING_MEMBERS &&
                (
                    wcvAdmin ||
                    (thirdPartyAdmin && me.associatedGroups && me.associatedGroups!.find(group => group.id === groupId)) ||
                    (me.groupMembers && me.groupMembers!.find(member => (member.group_role === GroupMemberRoleType.PRIMARY_LEADER || member.group_role === GroupMemberRoleType.LEADER) && member.group_id === groupId)) ||
                    (me.billingPartyMembers && me.billingPartyMembers.find(member => (member.primary_paying_member && member.billingParty && member.billingParty.booking && member.billingParty.booking.group_id === groupId))) ||
                    (me.myBillingParties && me.myBillingParties.find(billingParty => (billingParty.booking && billingParty.booking.group_id === groupId)))
                )
            ) {
                return true;
            }
        }
        return false;
    };
};